<template>
  <section class="player-contents" :key="'vod_player'">
    <!-- 플레이어 콘텐츠 영역 -->
    <div class="video-wrap">
      <div class="player-contents">
        <div class="player-area">
          <!-- [D] 예고편 영역 있는 경우 active 클래스 추가 -->
          <TrailerPlayer
            v-if="hasTrailer"
            :content-info="contentInfo"
            current-section="vod"
            class="active"
          />
          <PosterHorizontal
            v-else-if="contentImage.isHorizontal"
            :poster-image="contentImage.image"
            :poster-alt-text="season.title"
          />
          <PosterVertical
            v-else
            :poster-image="contentImage.image"
            :poster-alt-text="season.title"
          />

        </div>
        <!-- [D] 플레이어가 있는 경우 버튼 요소를 display: block 시켜주세요 -->
        <!-- [D] 기본값: 볼륨끄기 / 클릭이 되면 on 클래스 추가, 볼륨켜기로 변경 해주세요 -->
        <BtnToggleMuteTrailer v-if="isShowTrailerMuteBtn" :content-info="contentInfo"/>

        <div class="video-detail-area">
          <h1 class="logo-box">
            <BrandBadge v-if="brandLogo" :brand-logo="brandLogo" />
            <em v-if="season.titleLogoImage" class="logo"><img :src="titleLogImage(season.titleLogoImage)" width="" height="" :alt="season.title" /></em>
            <em v-else class="title">{{ season.title }}</em>
          </h1>

          <dl class="metadata-list">
            <dt class="a11y-hidden">메타 정보</dt>
            <dd class="dot-item"><em class="a11y-hidden">에피소드: </em>{{ `시즌 ${ Number(seasonList.count) || '1' }개` }}</dd>
            <dd v-if="metaData.targetAge" class="dot-item"><em class="a11y-hidden">시청연령: </em><AgeGrade :target-age="metaData.targetAge" :section="kmrbCode" :size="24" /></dd>
            <dd v-if="metaData.genreText" class="dot-item"><em class="a11y-hidden">종류: </em>{{ metaData.genreText }}</dd>
            <dt class="a11y-hidden">태그 정보</dt>
            <dd v-if="isCC" class="tag-item"><img :src="require(`@/assets/images/common/element-icons-tag-cc.svg`)" width="34" height="24" alt="자막" /></dd>
          </dl>

          <ul class="comment-list">
            <template v-for="(comment, index) in comments">
              <li v-if="comment" :key="`comment_${index}`">{{ comment }}</li>
            </template>
          </ul>

          <div class="essential-box">
            <div v-if="hasSeason" class="select-box">
              <PlayerFilterList
                :current-id="programid"
                :filter-item="seasonList"
                :base-api="seasonList.baseApi"
              />
            </div>
            <div class="play-button-box">
              <PlayerActionButton
                v-if="contentInfo"
                content-type="vod"
                :content-info="contentInfo"
                :landing-info="landingInfo"
                :key="contentid"
              />
            </div>
            <div v-if="!isPooqzone" class="icon-box">
              <ul>
                <li class="icon-item">
                  <BtnZzimWithApi
                    :is-on="getValue('zzim')"
                    :block-zzim="getValue('programid') === ''"
                    contents-type="program"
                    :contents-id="getValue('programid')"
                    :key="getValue('contentid')"
                  />
                </li>
                <li class="icon-item">
                  <button type="button" @click.prevent="openSharePopup">
                    <img :src="require('@/assets/images/common/element-icons-30-x-30-ic-detail-share.svg')" width="30" height="30" alt="공유"/>
                    <span class="icon-txt">공유</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="detail-info-box">
            <strong
              v-if="remainViewTime && !isComingSoon"
              class="sjt"
            >
              {{ episode.number}}. {{ episode.title || '에피소드' }}
            </strong>
            <div
              v-if="contentsStatus === 'continue' && !isComingSoon"
              class="time-bar"
            >
              <div class="graph">
                <span class="inner" :style="`width: ${viewRatio}`">
                  <em class="a11y-hidden">{{ viewRatio }}</em>
                </span>
              </div>
              <em class="text">{{ remainViewTime }}분 남음</em>
            </div>

            <p class="content-preview-box">
              <v-clamp class="content-clamp" :max-lines="2" ellipsis="..." >
                {{ renderSynopsis(synopsis) }}
                <template #after>
                  <a href="javascript:void(0)" class="more" @click.prevent="moveToDetailInfo"> 더보기</a>
                </template>
              </v-clamp>
            </p>

            <div v-if="isShowActorList && !isComingSoon" class="content-actor-box">
              <strong>출연 :</strong>
              <template v-for="(actor, index) in actorList">
                <span :key="index" class="content-actor-list">
                  <a @click.prevent="searchText(actor.text.trim())" href="#">{{ actor.text }}</a>
                </span>
                <template v-if="index !== actorList.length - 1">, </template>
              </template>
            </div>
          </div>

          <PlayerNotice :content-id="contentInfo.programid" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import cookie from '@/common/utils/cookie'
import { mapGetters } from 'vuex'
import { MENU, MOVE_TO_DETAIL_TAB } from '@/common/resources/const'
import { vodInfoBox, adjustHeight } from '@/common/resources/directives'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'
import { addPostfixAndUrl, titleTagNameChange } from '@/common/utils/common'
import { getRemainViewTime, getDecodedHTMLText } from '@/common/utils/player.util'
import { url } from '@/common/filters/url.filter'
import PlayerNotice from '@/components/player/PlayerNotice'
import PlayerActionButton from '@/components/player/PlayerActionButton'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
import PlayerDetailInfoMixin from '@/mixins/player.detail.info.mixin'
import BrandBadge from '@/components/player/BrandBadge'
import AgeGrade from '@/components/player/AgeGrade'
import PosterVertical from '@/components/player/PosterVertical'
import PosterHorizontal from '@/components/player/PosterHorizontal'
import PlayerFilterList from '@/components/player/PlayerFilterList'
import VClamp from 'vue-clamp'
import TrailerPlayer from '@/components/player/TrailerPlayer'
import BtnToggleMuteTrailer from '@/components/player/BtnToggleMuteTrailer'
import TrailerPlayerPageMixin from '@/mixins/trailer.player.page.mixin'
import { TRAILER_ATTR_BY_PLAYER_TYPE } from '@/common/resources/player.const'
import { resizeThumbnail } from '@/common/utils/image'

export default {
  name: 'VodPlayer',
  components: {
    PlayerFilterList,
    BtnZzimWithApi,
    PlayerActionButton,
    PlayerNotice,
    BrandBadge,
    AgeGrade,
    VClamp,
    PosterVertical,
    PosterHorizontal,
    TrailerPlayer,
    BtnToggleMuteTrailer
  },
  mixins: [PlayerDetailInfoMixin, TrailerPlayerPageMixin],
  filters: {
    addPostfixAndUrl,
    url
  },
  directives: {
    vodInfoBox,
    adjustHeight
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => ({})
    },
    landingInfo: {
      type: Object,
      default: () => ({})
    },
    dataOrderInfo: {
      type: Object
    },
    openDownloadPopup: {
      type: Function
    },
    openShareLayout: {
      type: Function
    },
    openSharePopup: {
      type: Function
    }
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn()
    }
  },
  computed: {
    ...mapGetters(['currentMenu']),
    brandLogo () {
      return _.get(this.contentInfo, 'brand_logolist.0', '')
    },
    contentid () {
      return _.get(this.contentInfo, 'contentid', '')
    },
    contentsStatus () {
      return _.get(this.landingInfo, 'contents_status', '')
    },
    comment () {
      return _.get(this.contentInfo, 'comment', '')
    },
    comments () {
      const { autocomment = '' } = this.contentInfo
      return [ autocomment, this.comment ]
    },
    contentImage () {
      // 우선 순위 1. 세로형/로고n  2. 가로형/로고y  3. 세로형/로고y
      const {
        season_horizontal_logoN_image: imageHorizonWithoutLogo = '',
        season_vertical_logoY_image: imageVerticalWithLogo = '',
        season_horizontal_logoY_image: imageHorizonWithLogo = ''
      } = this.contentInfo
      const hasVerticalLogoImage = !imageVerticalWithLogo && imageHorizonWithLogo

      let isHorizontal = imageHorizonWithoutLogo.length > 0
      if (hasVerticalLogoImage) isHorizontal = true

      const image = imageHorizonWithoutLogo || imageVerticalWithLogo || imageHorizonWithLogo
      return { isHorizontal, image }
    },
    episode () {
      const { episodenumber: episodeNumber = '', episodetitle: title = '', episodesynopsis: synopsis = '' } = this.contentInfo
      const number = episodeNumber.replace('회', '')
      return { number, title, synopsis }
    },
    kmrbCode () {
      const { kmrbcode } = this.contentInfo
      return kmrbcode ? 'movie' : 'vod'
    },
    metaData () {
      const { genretext: genreText = '', targetage: targetAge = '' } = this.contentInfo
      return { genreText, targetAge }
    },
    programid () {
      return this.contentInfo?.programid || ''
    },
    remainViewTime () {
      const { playtime = '0', viewtime = '0' } = this.contentInfo
      const hasViewTime = this.contentsStatus === 'continue'
      return hasViewTime ? getRemainViewTime(playtime, viewtime) : 0
    },
    season () {
      const { seasontitlelogoimage: titleLogoImage = '', seasontitle: title = '', seasonsynopsis: synopsis } = this.contentInfo
      return { titleLogoImage, title, synopsis }
    },
    seasonList () {
      const { season_list: seasonList = {} } = this.contentInfo
      const { count = '0', base_api: baseApi = '', season_item_list: seasonItemList = [] } = seasonList

      return { count, baseApi, seasonItemList }
    },
    synopsis () {
      // contentid 로 조회 할 경우 content_status 에 continue 가 내려오지 않아 viewtime 체크 (e.g 홈 - 실시간 인기 콘텐츠 - 이미 시청 했을 경우, 콘텐츠 상세 - 플레이어 재생 - 뒤로가기 - 콘텐츠 상세(contentid 로 조회) 일 경우)
      return (this.contentsStatus === 'continue')
        ? (this.episode.synopsis || this.season.synopsis)
        : this.season.synopsis
    },
    viewRatio () {
      return `${Number(_.get(this.contentInfo, 'viewratio', '')) * 100}%`
    },
    isComingSoon () {
      return this.contentsStatus === 'commingsoon'
    },
    isShowActorList () { // 시청이력이 없고, 로그아웃 되어 있을 경우 출연진 미노출
      // contentid 로 조회 할 경우 content_status 에 continue 가 내려오지 않아 viewtime 체크 (e.g 홈 - 실시간 인기 콘텐츠 - 이미 시청 했을 경우, 콘텐츠 상세 - 플레이어 재생 - 뒤로가기 - 콘텐츠 상세(contentid 로 조회) 일 경우)
      return this.hasActorList && (this.contentsStatus === 'continue' || this.remainViewTime > 0)
    },
    isCC () {
      return _.get(this.contentInfo, 'isCC', '').toLowerCase() === 'y'
    },
    isVod () {
      return this.currentMenu === MENU.BROADCAST
    },
    hasSeason () {
      return Number(this.seasonList.count) > 1
    },
    hasTrailer () {
      return _.get(this.contentInfo, TRAILER_ATTR_BY_PLAYER_TYPE['vod'].id, '') !== ''
    },
    /**
     * 예고편 플레이어 음소거 버튼 노출 여부 (트레일러가 있고 재생상태라면)
     * @returns {false|boolean}
     */
    isShowTrailerMuteBtn () {
      return this.hasTrailer && this.isTrailerPlaying
    }
  },
  methods: {
    titleLogImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: 20, quality: 80 })
    },
    getValue (path) {
      return _.get(this.contentInfo, path, '')
    },
    searchText (searchWord) {
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: {
          searchWord: searchWord
        }
      })
    },
    renderSynopsis (synopsis) {
      return getDecodedHTMLText(synopsis)
    },
    moveToDetailInfo () {
      this.$events.$emit(MOVE_TO_DETAIL_TAB)
    },
    addClassSynopsisText () {
      const synopsisDOM = document.querySelector('.content-clamp > span > span')
      if (this.synopsis !== '' && synopsisDOM) synopsisDOM.classList.add('text')
    }
  },
  created () {
    titleTagNameChange(
      `${this.season?.title || '프로그램 상세화면'} : 웨이브`
    )
  },
  mounted () {
    this.addClassSynopsisText()
  },
  watch: {
    contentInfo () {
      titleTagNameChange(
        `${this.season?.title || '프로그램 상세화면'} : 웨이브`
      )
    }
  }
}
</script>
